import { api } from '@cwd/lib/main';

export interface Industry {
    IndustryId: string;
    Name: string;
}

export interface CategorizedSubscriptions {
    Paying: PayingSubscription[];
    Cancelled: CancelledSubscription[];
}

export interface PayingSubscription {
    ServiceSubscriptionId: string;
    ServiceSubscriptionTier: { Name: string };
    ServiceLevel: { Name: string };
    Status: number;
    MonthlyPrice: number;
    CurrentMonthlyAddonPrice: number;
    MonthlyTotalDiscount: number;
    ServiceLevelPrice: { CurrencyCode: string };
    DefaultPaymentMethod: number;
    RenewalPeriod: number;
    PaidUntil: string | null;
    ClientCompany: {
        ClientCompanyId: string;
        Name: string;
        IndustryId: string | null;
    };
}

export interface CancelledSubscription {
    ServiceSubscriptionId: string;
    ServiceSubscriptionTier: { Name: string };
    ServiceLevel: { Name: string };
    MonthlyPrice: number;
    CurrentMonthlyAddonPrice: number;
    MonthlyTotalDiscount: number;
    ServiceLevelPrice: { CurrencyCode: string };
    Cancelled: string | null;
    End: string | null;
    ClientCompany: { Name: string };
}

export async function getCategorized(): Promise<CategorizedSubscriptions> {
    return api.get('/BackOffice/ServiceSubscriptions/Categorized');
}

export async function getIndustries(): Promise<Industry[]> {
    return api.get('/Industries');
}

function toFormEncoded(value: unknown): string {
    return `=${encodeURIComponent(value == null ? '' : String(value))}`;
}

export async function saveClientCompanyProperty(clientCompanyId: string, property: string, value: unknown): Promise<void> {
    return api.post(`/BackOffice/ClientCompanies/${clientCompanyId}/${property}`, toFormEncoded(value), 'application/x-www-form-urlencoded; charset=UTF-8');
}

export async function saveSubscriptionProperty(serviceSubscriptionId: string, property: string, value: unknown): Promise<void> {
    return api.post(`/BackOffice/ServiceSubscriptions/${serviceSubscriptionId}/${property}`, toFormEncoded(value), 'application/x-www-form-urlencoded; charset=UTF-8');
}
